<template>
  <div class="container-fluid">


    <hr />
    <div class="row mt-3">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body p-0">
            <div class="embed-responsive">
              <iframe
                :src="reportUrl"
                frameborder="0"
                style="border: 0; width: 100%; height: calc(100vh - 200px); min-height: 600px;"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerdePorMeta",
  data() {
    return {
      reportUrl: "https://lookerstudio.google.com/embed/reporting/370c701c-b42f-480d-a92c-29fdc914d8cc/page/p_z6bkqqmjwd"
    };
  }
};
</script>

<style scoped>
.embed-responsive {
  position: relative;
  width: 100%;
}
</style>
